<canvas #canvasRef width="100%" height="100%"></canvas>
